import { render } from "./permen.vue?vue&type=template&id=74926646&scoped=true"
import script from "./permen.vue?vue&type=script&lang=js"
export * from "./permen.vue?vue&type=script&lang=js"

import "./permen.vue?vue&type=style&index=0&id=74926646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74926646"]])

export default __exports__